import { render, staticRenderFns } from "./GChatBrandListItem.vue?vue&type=template&id=1aeaf007&scoped=true&"
import script from "./GChatBrandListItem.vue?vue&type=script&lang=ts&"
export * from "./GChatBrandListItem.vue?vue&type=script&lang=ts&"
import style0 from "./GChatBrandListItem.vue?vue&type=style&index=0&id=1aeaf007&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aeaf007",
  null
  
)

export default component.exports